import React from "react";

import { a } from "@react-spring/web";

import { useIntersect } from "hooks/useIntersect";
import { useAnimateInSpring, IAnimateInProps } from "hooks/useAnimateInSpring";
import { initialOffset } from "components/Animations/SpringProperties/SpringProperties";

import classNames from "classnames";
import * as fromProjects from "store/Projects";

interface IOwnProps {
  details: fromProjects.IProjectChallenge;
}

type IProps = IOwnProps & IAnimateInProps;

const ProjectChallenge: React.FC<IProps> = ({
  animationReady,
  details,
  ...props
}) => {
  const [inViewRef, inView] = useIntersect({
    startObserving: animationReady,
  });

  const animateInSpring = useAnimateInSpring(inView);

  const sectionStyles = {
    backgroundColor: details.backgroundColor,
  };

  const textStyles = {
    opacity: animateInSpring.active,
    transform: animateInSpring.active.to(
      (x) => `translateY(calc(${initialOffset(x)}))`
    ),
  };

  return (
    <section
      ref={inViewRef}
      className={classNames(
        "projectChallengeWrapper",
        details.backgroundShade + "BackgroundShade"
      )}
      style={sectionStyles}
    >
      <div className="messageWrapper">
        <a.p style={textStyles}>{details.challenge}</a.p>
      </div>
    </section>
  );
};

export default ProjectChallenge;
